var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteNotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.713 20.25c0 1.519-1.215 2.75-2.713 2.75s-2.713-1.231-2.713-2.75zM12 1c.749 0 1.356.616 1.356 1.375v.895a6.895 6.895 0 0 1 3.232 1.647l2.42-2.42a1.7 1.7 0 1 1 2.404 2.405l-2.947 2.949c.206.654.317 1.354.317 2.087 0 4.395 1.533 5.737 2.353 6.63.254.276.367.608.365.932-.004.705-.55 1.375-1.361 1.375h-12.7l-2.537 2.537a1.7 1.7 0 0 1-2.283.11l-.121-.11a1.7 1.7 0 0 1 0-2.404l.469-.47A1.415 1.415 0 0 1 2.5 17.5c-.002-.324.11-.656.365-.933.82-.892 2.353-2.234 2.353-6.63 0-3.338 2.31-6.01 5.426-6.667v-.895C10.644 1.615 11.25 1 12 1zm7.008 1.498-16.51 16.51a1.7 1.7 0 1 0 2.404 2.404l16.51-16.51a1.7 1.7 0 0 0-2.404-2.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.705 3.205a.7.7 0 0 0-.99 0l-16.51 16.51a.7.7 0 0 0 .99.99l16.51-16.51a.7.7 0 0 0 0-.99z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteNotify);
export default __webpack_public_path__ + "static/media/mute-notify.167ea79e.svg";
export { ForwardRef as ReactComponent };